import { combineReducers } from 'redux';

// Add other reducers here
import Help from './help/Reducer';
import Recent from './recent/Reducer';

const Reducers = combineReducers({
  Help,
  Recent
});

export default Reducers;



// WEBPACK FOOTER //
// ./src/modules/state/Reducers.js